import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useJournalEdit } from '@/module/Journal/model/JournalQuery';
import { JournalSchema, defaultJournalValues, journalSchema } from '@/module/Journal/model/JournalSchema';

import { useAppNotification } from '@feature/utils';

import { JournalForm } from './JournalForm';
import { Journal } from './model/JournalTypes';

interface JournalEditProps {
  journal: Journal;
}

const convert = (journal: Journal): JournalSchema => ({
  ...journal,
});

export function JournalEdit(props: JournalEditProps) {
  const { journal } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useJournalEdit(journal.id);

  const notification = useAppNotification();
  const onSubmit = (values: JournalSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(journal), [journal]);
  const navigate = useNavigate();

  return (
    <JournalForm
      title={t('journals.form.title.edit')}
      schema={journalSchema}
      defaultValues={defaultJournalValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
